export const statuses = [
  "affiliate",
  "candidate",
  "no contact",
  "pending",
  "dead channel",
  "no answer",
  "no host",
  "not interested",
  "paid review offer",
  "sponsored",
  "signed",
  "trial",
];
